/* Hand Hearth thumb stabilizer (layout hand-hearth): bundle picker, buy now, cart drawer, sticky bar.
   Replaces the Kaching Bundles / Kaching Cart apps of handhearth.com. */
(function () {
  'use strict';

  var LABELS = {
    'Black': 'שחור', 'Skin Color': 'בז׳', 'Beige': 'בז׳', 'Skin': 'בז׳', 'Purple': 'סגול', 'Grey': 'אפור', 'Gray': 'אפור',
    'Pink': 'ורוד', 'S': 'S (קטן)', 'Small': 'S (קטן)', 'M': 'M (בינוני)', 'Medium': 'M (בינוני)', 'L': 'L (גדול)', 'Large': 'L (גדול)'
  };
  var SWATCH = {
    'Black': ['#1d1d1d', '#000'], 'Skin Color': ['#d9bf9f', '#c4a684'], 'Beige': ['#d9bf9f', '#c4a684'], 'Skin': ['#d9bf9f', '#c4a684'],
    'Purple': ['#800080', '#730073'], 'Grey': ['#9a9a9a', '#888'], 'Gray': ['#9a9a9a', '#888'], 'Pink': ['#f2b8c6', '#e0a3b3']
  };
  var label = function (v) { return LABELS[v] || v; };

  function money(cents) {
    var fmt = window.hhtMoneyFormat || '{{amount}} ש״ח';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, ''); // whole amounts without .00, like money_without_trailing_zeros
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  /* ---------------- bundle picker ---------------- */
  var bundle = document.querySelector('[data-hht-bundle]');
  var variants = [];
  if (bundle) {
    try { variants = JSON.parse(bundle.querySelector('[data-hht-variants]').textContent); } catch (e) { variants = []; }
  }

  /* free gifts (snippets/hht-gifts): ₪0 products, one of each while 2+ pairs are in the cart */
  var gift = null;
  try { gift = JSON.parse(document.querySelector('[data-hht-gift]').textContent); } catch (e) { gift = null; }
  if (gift && !gift.items.length) gift = null;
  function giftFor(item) {
    if (!gift) return null;
    for (var i = 0; i < gift.items.length; i++) if (gift.items[i].product_id === item.product_id) return gift.items[i];
    return null;
  }
  function isGift(item) { return !!giftFor(item); }
  function giftLines() {
    return gift.items.map(function (g) { return { id: g.variant, quantity: 1, properties: { _gift: '1' } }; });
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) if (opts[j] != null && v.options[j] !== opts[j]) ok = false;
      if (ok) return v;
    }
    return null;
  }

  function paintSwatches(scope) {
    scope.querySelectorAll('.hht-select--swatch').forEach(function (w) {
      var sel = w.querySelector('select'), sw = w.querySelector('[data-hht-swatch]');
      var c = SWATCH[sel.value] || ['#ccc', '#bbb'];
      sw.style.setProperty('--kaching-swatch-color', c[0]);
      sw.style.setProperty('--kaching-swatch-border-color', c[1]);
    });
  }

  function markUnavailable(pick) {
    var selects = pick.querySelectorAll('select[data-hht-option]');
    selects.forEach(function (sel) {
      var idx = +sel.dataset.hhtOption;
      Array.prototype.forEach.call(sel.options, function (o) {
        var opts = [];
        selects.forEach(function (s) { opts[+s.dataset.hhtOption] = s.value; });
        opts[idx] = o.value;
        var v = findVariant(opts);
        o.disabled = !v || !v.available;
        o.textContent = label(o.value) + (o.disabled ? ' – אזל' : '');
      });
    });
  }

  function selectedBar() { return bundle && bundle.querySelector('.kaching-bundles__bar--selected'); }

  function chosenItems() {
    var bar = selectedBar();
    if (!bar) return [];
    var counts = {}, order = [];
    bar.querySelectorAll('[data-hht-pick]').forEach(function (pick) {
      var opts = [];
      pick.querySelectorAll('select[data-hht-option]').forEach(function (s) { opts[+s.dataset.hhtOption] = s.value; });
      var v = findVariant(opts);
      if (!v) return;
      if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
      counts[v.id]++;
    });
    return order.map(function (id) { return { id: id, quantity: counts[id] }; });
  }

  if (bundle) {
    bundle.querySelectorAll('[data-hht-bar] input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        bundle.querySelectorAll('[data-hht-bar]').forEach(function (b) {
          b.classList.toggle('kaching-bundles__bar--selected', b.contains(r) && r.checked);
        });
      });
    });
    // clicks on the selects must not re-toggle the radio label
    bundle.querySelectorAll('.kaching-bundles__bar-variants').forEach(function (el) {
      el.addEventListener('click', function (e) { if (e.target.closest('select')) e.preventDefault(); });
    });
    bundle.querySelectorAll('[data-hht-pick]').forEach(function (pick) {
      markUnavailable(pick);
      pick.addEventListener('change', function () { paintSwatches(pick); markUnavailable(pick); });
    });
    paintSwatches(bundle);
    // the gift card is open only while the 2-pair bar is selected; tapping the lock selects it
    var paintGift = function () {
      var bar = selectedBar(), locked = !gift || !bar || +bar.dataset.qty < gift.min;
      var disc = bundle.querySelector('[data-hht-autodisc]');
      if (disc && bar) { var amt = disc.getAttribute('data-save-' + bar.dataset.qty) || ''; disc.querySelector('[data-hht-autodisc-amount]').textContent = amt; disc.style.display = amt ? '' : 'none'; }
      bundle.querySelectorAll('[data-hht-gift-card]').forEach(function (c) { c.classList.toggle('is-locked', locked); });
    };
    bundle.querySelectorAll('[data-hht-bar] input[type=radio]').forEach(function (r) { r.addEventListener('change', paintGift); });
    bundle.querySelectorAll('[data-hht-gift-unlock]').forEach(function (unlock) { unlock.addEventListener('click', function () {
      var r = bundle.querySelector('[data-hht-bar][data-qty="' + (gift ? gift.min : 2) + '"] input[type=radio]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }); });
    paintGift();
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = document.querySelector('[data-hht-cart]');
  var linesEl = drawer && drawer.querySelector('[data-hht-cart-lines]');
  var totalEl = drawer && drawer.querySelector('[data-hht-cart-total]');

  function compareFor(item) {
    var v = null;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === item.variant_id) v = variants[i];
    var unit = v && v.compare ? v.compare : item.original_price;
    return Math.max(unit * item.quantity, item.original_line_price);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  // one card per product, like Kaching Cart's bundle line ("2x title", #1 / #2 option rows)
  function groupLines(items) {
    var groups = [], byProduct = {};
    items.forEach(function (item, i) {
      var g = byProduct[item.product_id];
      if (!g) { g = byProduct[item.product_id] = { item: item, lines: [], qty: 0, old: 0, fin: 0 }; groups.push(g); }
      g.lines.push({ n: i + 1, item: item });
      g.qty += item.quantity;
      g.old += compareFor(item);
      g.fin += item.final_line_price;
    });
    return groups;
  }

  function optText(item) {
    return (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
      .map(function (o) { return esc(label(o.value)); }).join(' / ');
  }

  function giftHtml(g) {
    var item = g.item, old = 0;
    var info = giftFor(item);
    g.lines.forEach(function (l) { old += info.compare * l.item.quantity; });
    return '<div class="hht-line hht-line--gift">' +
      '<div class="hht-line__img">' + (item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '') + '</div>' +
      '<div class="hht-line__info">' +
        '<div class="hht-line__top"><p class="hht-line__title">🎁 ' + esc(info.name) + '</p>' +
        '<div class="hht-line__prices">' + (old ? '<s class="hht-line__old">' + money(old) + '</s>' : '') + '<b class="hht-line__final">חינם</b></div></div>' +
        '<p class="hht-line__opt">מתנה עם 2 זוגות</p>' +
      '</div></div>';
  }

  function groupHtml(g) {
    if (isGift(g.item)) return giftHtml(g);
    var item = g.item, sale = g.old > g.fin;
    // the stabilizer's CJ variant photos are plain product shots; the cart shows the Hebrew main image like the PDP
    var img = (gift && gift.main_image && item.product_id === gift.main_id) ? gift.main_image : (item.image || '');
    var rows = [], k = 0;
    g.lines.forEach(function (l) {
      var t = optText(l.item);
      for (var q = 0; q < l.item.quantity; q++) { k++; if (t) rows.push('<p class="hht-line__opt"><span>#' + k + '</span> ' + t + '</p>'); }
    });
    var lineIds = g.lines.map(function (l) { return l.n; }).join(',');
    return '<div class="hht-line" data-lines="' + lineIds + '">' +
      '<div class="hht-line__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="">' : '') + '</div>' +
      '<div class="hht-line__info">' +
        '<div class="hht-line__top"><p class="hht-line__title"><span class="hht-line__qty">' + g.qty + 'x</span> ' + esc(item.product_title) + '</p>' +
        '<div class="hht-line__prices">' + (sale ? '<s class="hht-line__old">' + money(g.old) + '</s>' : '') +
        '<b class="hht-line__final">' + money(g.fin) + '</b></div></div>' +
        (sale ? '<p class="hht-line__tag"><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M1 8.6V2a1 1 0 0 1 1-1h6.6l6.4 6.4-7.6 7.6z" fill="currentColor"/><circle cx="4.5" cy="4.5" r="1.3" fill="#fff"/></svg>מבצע סוף עונה</p>' : '') +
        (rows.length ? '<p class="hht-line__opts">צבע, מידה:</p>' + rows.join('') : '') +
        '<div class="hht-line__row"><div class="hht-qty">' +
          '<button type="button" data-hht-qty="-1" aria-label="הפחתה">−</button><span>' + g.qty + '</span>' +
          '<button type="button" data-hht-qty="1" aria-label="הוספה">+</button></div>' +
          (sale ? '<span class="hht-line__save">חסכת ' + money(g.old - g.fin) + '</span>' : '') +
          '<button type="button" class="hht-line__trash" data-hht-remove aria-label="הסרה"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>' +
      '</div></div>';
  }

  function render(cart) {
    if (!drawer) return;
    if (!cart.item_count) {
      linesEl.innerHTML = '<p class="hht-cart__empty">הסל שלך ריק</p>';
    } else {
      lastCart = cart;
      // the gift card always sits under the pairs, whichever line Shopify put first
      var groups = groupLines(cart.items);
      groups = groups.filter(function (g) { return !isGift(g.item); }).concat(groups.filter(function (g) { return isGift(g.item); })
        .sort(function (a, b) { return gift.items.indexOf(giftFor(a.item)) - gift.items.indexOf(giftFor(b.item)); }));
      linesEl.innerHTML = groups.map(groupHtml).join('');
    }
    totalEl.textContent = money(cart.total_price);
    document.querySelectorAll('.cart-count-bubble, [data-hht-count]').forEach(function (b) { b.remove(); });
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon && cart.item_count) {
      var bub = document.createElement('div');
      bub.className = 'cart-count-bubble';
      bub.setAttribute('data-hht-count', '');
      bub.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
      icon.appendChild(bub);
    }
  }

  var lastCart = null;

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(syncGift).then(function (c) { render(c); return c; }); }

  // exactly one line (qty 1) of each gift while 2+ pairs are in the cart, none otherwise
  function syncGift(cart) {
    if (!gift) return cart;
    var pairs = 0, seen = {};
    cart.items.forEach(function (item) { if (!isGift(item) && item.product_id === gift.main_id) pairs += item.quantity; });
    var on = pairs >= gift.min, updates = {}, dirty = false, missing = [];
    cart.items.forEach(function (item) {
      if (!isGift(item)) return;
      var want = on && !seen[item.product_id] ? 1 : 0;
      seen[item.product_id] = true;
      if (item.quantity !== want) { updates[item.key] = want; dirty = true; }
    });
    if (on) gift.items.forEach(function (g) { if (!seen[g.product_id]) missing.push({ id: g.variant, quantity: 1, properties: { _gift: '1' } }); });
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    };
    if (!dirty && !missing.length) return cart;
    var job = dirty ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
    return job.then(function () { return missing.length ? post('/cart/add.js', { items: missing }) : null; }).then(getCart);
  }

  function open() {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hht-lock');
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hht-lock');
  }

  function change(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refresh(); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-hht-cart-close]')) { close(); return; }
      var card = e.target.closest('.hht-line');
      if (!card || !lastCart) return;
      var ids = card.dataset.lines.split(',').map(Number);
      var qtyBtn = e.target.closest('[data-hht-qty]');
      if (qtyBtn) {
        var last = ids[ids.length - 1], item = lastCart.items[last - 1];
        change(last, Math.max(0, item.quantity + +qtyBtn.dataset.hhtQty));
      } else if (e.target.closest('[data-hht-remove]')) {
        var updates = {};
        ids.forEach(function (n) { updates[lastCart.items[n - 1].key] = 0; });
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refresh);
      }
    });
    drawer.querySelector('[data-hht-checkout]').addEventListener('click', function () { window.location.href = '/checkout'; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-hht-cart-open]');
    if (opener) { e.preventDefault(); refresh().then(open); }
  });

  /* ---------------- buy now ---------------- */
  function buy(btn) {
    var items = chosenItems();
    if (!items.length) return;
    var bar = selectedBar();
    if (gift && bar && +bar.dataset.qty >= gift.min) items = items.concat(giftLines());
    btn.classList.add('loading');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'error'); });
      return refresh().then(open);
    }).catch(function (err) {
      alert(err.message && /sold out|stock|available/i.test(err.message) ? 'המוצר אזל מהמלאי במידה/צבע שנבחרו' : 'משהו השתבש, נסו שוב');
    }).then(function () { btn.classList.remove('loading'); btn.disabled = false; });
  }

  document.querySelectorAll('[data-hht-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () { buy(btn); });
  });

  /* ---------------- sticky bar ---------------- */
  var sticky = document.querySelector('[data-hht-sticky]');
  var mainBtn = document.querySelector('.shop-add-to-cart-button[data-hht-buy]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var passed = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      });
    }).observe(mainBtn);
    sticky.querySelector('[data-hht-sticky-buy]').addEventListener('click', function () {
      var anchor = document.querySelector('[data-hht-bundle]') || mainBtn;
      window.scrollTo({ top: anchor.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  }

  /* their guarantee CTA (TRY NOW) scrolls up to the bundle */
  document.querySelectorAll('a[href="#hht-buy"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var anchor = document.querySelector('[data-hht-bundle]');
      if (anchor) window.scrollTo({ top: anchor.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  });

  /* mobile menu drawer (their Dawn header-drawer, without Dawn's JS) */
  var menu = document.querySelector('#Details-menu-drawer-container');
  if (menu) {
    var summary = menu.querySelector('summary');
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var opening = !menu.hasAttribute('open');
      if (opening) {
        var hdr = menu.closest('header') || menu.closest('.header-wrapper');
        if (hdr) document.documentElement.style.setProperty('--hht-drawer-top', Math.max(0, hdr.getBoundingClientRect().bottom) + 'px');
        menu.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () { menu.classList.add('menu-opening'); });
        document.documentElement.classList.add('hht-lock');
      } else {
        menu.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('hht-lock');
        setTimeout(function () { menu.removeAttribute('open'); }, 250);
      }
    });
    menu.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function () { if (menu.hasAttribute('open')) summary.click(); });
    });
  }

  /* ---------------- product title: their shop-product-details.js swaps to the mobile size at <=767px ---------------- */
  var titles = document.querySelectorAll('.shop-product-title[data-font-size][data-mobile-font-size]');
  function sizeTitles() {
    var mobile = window.innerWidth <= 767;
    titles.forEach(function (t) {
      t.style.setProperty('font-size', t.getAttribute(mobile ? 'data-mobile-font-size' : 'data-font-size') + 'px', 'important');
    });
  }
  if (titles.length) { sizeTitles(); window.addEventListener('resize', sizeTitles); }

  refresh();
})();
